import React, { useState } from 'react';
import { useEffect } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Table, Form, Toggle } from 'rsuite';
import boardMemberService from '../../../../services/Public/boardMember.service';
import LoadingSpinner from '../../../Shared/GenericComponents/LoadingSpinner';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import GenericPagination from '../../../Shared/Grid/GenericPagination';
import { sort_by } from '../../../Shared/HelperFunctions';
import Swal from 'sweetalert2';
import { AccessibleToggle } from '../../../Shared/GenericComponents/AccessibleComponents';

function BoardApprovals() {
    const push = useNavigate();
    const [hasLoaded, setHasLoaded] = useState(false);
    const [model, setModel] = useState({
        reminderDays: 15
    });
    const [optIn, setOptIn] = useState(false);
    const [pendingGridDisplayLength, setPendingGridDisplayLength] = useState(10);
    const [pendingGridPage, setPendingGridPage] = useState(1);
    const [pendingGrid, setPendingGrid] = useState([]);
    const [pendingSortColumn, setPendingSortColumn] = useState("dateCrte");
    const [pendingSortType, setPendingSortType] = useState("asc");
    const [actionedSortColumn, setActionedSortColumn] = useState("dateCrte");
    const [actionedSortType, setActionedSortType] = useState("asc");
    const [actionedGridLength, setActionedGridLength] = useState(20);
    const [actionedGridPage, setActionedGridPage] = useState(1);
    const [actionedGrid, setActionedGrid] = useState([]);


    const dispatch = useDispatch();
    useEffect(() => {
        boardMemberService.getBoardMemberResponses().then((response) => {
            setPendingGrid(response.data.filter(x => x.boardMemberDecision == "Pending"));
            setActionedGrid(response.data.filter(x => x.boardMemberDecision != "Pending"));
            setHasLoaded(true);
        });
        boardMemberService.getBoardMemberEmailSetting().then((response) => {
            setModel({ reminderDays: response.data.daysUntilReminder });
            setOptIn(response.data.emailOptedIn);
        })
    }, [])

    const getPendingGridData = () => {
        var sortedData = pendingGrid.sort(sort_by(pendingSortColumn, pendingSortType !== "asc"));
        return sortedData.filter((v, i) => {
            const start = pendingGridDisplayLength * (pendingGridPage - 1);
            const end = start + pendingGridDisplayLength;
            return i >= start && i < end;
        })
    }
    const filteredPendingData = getPendingGridData();

    const getActionedGridData = () => {
        var sortedData = actionedGrid.sort(sort_by(actionedSortColumn, actionedSortType !== "asc"));
        return sortedData.filter((v, i) => {
            const start = actionedGridLength * (actionedGridPage - 1);
            const end = start + actionedGridLength;
            return i >= start && i < end;
        })
    }
    const filteredActionedData = getActionedGridData();

    const handleSortColumn = (sortColumn, sortType, gridType) => {
        if (gridType == "Pending") {
            setPendingSortColumn(sortColumn);
            setPendingSortType(sortType);
        }
        else {
            setActionedSortColumn(sortColumn);
            setActionedSortType(sortType);
        }
    }
    const validateDays = () => {
        if (model.reminderDays < 1) {
            Swal.fire({
                position: "top-end",
                icon: "error",
                toast: true,
                showConfirmButton: false,
                html: "<h4>&nbsp;Days until reminder must be greater than 0</h4>",
                timer: 2000
            });
            return false;
        }
        return true;
    }
    const toggleOptIn = () => {
        if (validateDays()) {
            var newOptIn = !optIn;
            setOptIn(newOptIn);
            boardMemberService.saveBoardMemberEmailSetting(newOptIn, model.reminderDays).then((response) => {
                if (response.data)
                    Swal.fire({
                        position: "top-end",
                        icon: "success",
                        toast: true,
                        showConfirmButton: false,
                        html: "<h4>&nbsp;Email Settings Successfully Saved</h4>",
                        timer: 2000
                    });
            })
        }
    }
    const onSubmit = () => {
        if (validateDays()) {
            boardMemberService.saveBoardMemberEmailSetting(optIn, model.reminderDays).then((response) => {
                if (response.data)
                    Swal.fire({
                        position: "top-end",
                        icon: "success",
                        toast: true,
                        showConfirmButton: false,
                        html: "<h4>&nbsp;Email Settings Successfully Saved</h4>",
                        timer: 2000
                    });
            })
        }
    }

    const navigateToBoardApproval = async (rowData) => {
        dispatch({ type: "PERSIST_CURRENT_BOARD_REPONSE_PARENT_TYPE_ID", payload: rowData.parentTypeId });
        dispatch({ type: "PERSIST_CURRENT_BOARD_MEMBER_RESPONSE_ID", payload: rowData.boardMemberResponseId });
        push("/individual/boardApprovals/boardApproval");
    }
    return (
        <Container fluid>
            <h4 className="mb-3">Board Member Approvals</h4>
            <Row>
                <Col>
                    <Form formValue={model} onSubmit={onSubmit} layout="inline" onChange={formValue => {
                        setModel({ ...formValue })
                    }}>
                        <Card style={{ marginRight: '0px' }}>
                            <Card.Header>
                                <Row>
                                    <Col>
                                        <h4>Email Reminders</h4>
                                    </Col>
                                    <Col style={{ textAlign: 'right' }}>
                                        <Form.Group style={{ width: "100%", marginBottom: '5px' }}>
                                            <label className="switch" aria-label="Opt-In">
                                                <input name="optedIn" checked={optIn} onChange={() => { toggleOptIn() }} type="checkbox" />
                                                <span className="slider round"></span>
                                            </label><br />
                                            <Form.ControlLabel style={{ marginTop: '2px', marginRight: '10px', marginLeft: '10px' }}><b>Opt-In</b></Form.ControlLabel>
                                            <Form.HelpText className="d-none">Opt-In</Form.HelpText>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                <p>To ensure you never miss an approval, opt-in to email reminders by clicking the toggle above. Set the number of days before receiving a reminder email using the box below—these reminders will continue to be at regular intervals until the application/reinstatement is completed.</p>
                                <br />
                                <Form.Group style={{ width: "100%", marginBottom: '5px' }}>
                                    <Form.Control type="number" name="reminderDays" style={{ width: "75px" }} />
                                    <Form.ControlLabel style={{ marginRight: '0px', marginLeft: '10px' }}>Days Until Reminder</Form.ControlLabel>
                                    <Form.HelpText className="d-none">Days Until Reminder</Form.HelpText>
                                </Form.Group>
                                <Button name="reminderSubmit" type="submit" variant="primary" className="me-2">Save</Button>
                            </Card.Body>
                        </Card>
                    </Form>
                </Col>
            </Row>
            <br />
            <Row className="mb-3">
                <Col>
                    <Card>
                        <Card.Header><h5>Awaiting Recommendation</h5></Card.Header>
                        <Card.Body>
                            {hasLoaded ?
                                <>
                                    <Table
                                        wordWrap
                                        autoHeight
                                        data={filteredPendingData}
                                        onSortColumn={(sortColumn, sortType) => { handleSortColumn(sortColumn, sortType, "Pending") }}
                                        sortColumn={pendingSortColumn}
                                        sortType={pendingSortType}>
                                        <Table.Column flexGrow={1}>
                                            <Table.HeaderCell>
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => (
                                                    <>
                                                        <Button onClick={() => { navigateToBoardApproval(rowData) }}>View</Button>
                                                    </>
                                                )}
                                            </Table.Cell>
                                        </Table.Column>

                                        <Table.Column flexGrow={1} sortable>
                                            <Table.HeaderCell>
                                                Type
                                            </Table.HeaderCell>
                                            <Table.Cell dataKey="boardAssignmentType">
                                                {rowData => (rowData.boardAssignmentType)}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} sortable>
                                            <Table.HeaderCell>
                                                Name
                                            </Table.HeaderCell>
                                            <Table.Cell dataKey="entityName">
                                                {rowData => (rowData.entityName)}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} sortable>
                                            <Table.HeaderCell>
                                                Date Created
                                            </Table.HeaderCell>
                                            <Table.Cell dataKey="dateCrte" sortable>
                                                {rowData => (rowData.dateCrte ? new Date(rowData.dateCrte).toLocaleDateString() : '')}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1}>
                                            <Table.HeaderCell>
                                                Date Received
                                            </Table.HeaderCell>
                                            <Table.Cell dataKey="dateReceived" sortable>
                                                {rowData => (rowData.dateReceived ? new Date(rowData.dateReceived).toLocaleDateString() : '')}
                                            </Table.Cell>
                                        </Table.Column>

                                    </Table>
                                    <GenericPagination dataLength={pendingGrid.length} setPage={setPendingGridPage} setDisplayLength={setPendingGridDisplayLength} />
                                </>
                                : <LoadingSpinner />
                            }
                        </Card.Body>
                    </Card></Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Card>
                        <Card.Header><h5>Recommendation Received</h5></Card.Header>
                        <Card.Body>
                            {hasLoaded ?
                                <>
                                    <Table
                                        wordWrap
                                        autoHeight
                                        data={filteredActionedData}
                                        onSortColumn={(sortColumn, sortType) => { handleSortColumn(sortColumn, sortType, "Actioned"); }}
                                        sortColumn={actionedSortColumn}
                                        sortType={actionedSortType}>
                                        <Table.Column flexGrow={1}>
                                            <Table.HeaderCell>
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => (
                                                    <>
                                                        <Button onClick={() => { navigateToBoardApproval(rowData) }}>View</Button>
                                                    </>
                                                )}
                                            </Table.Cell>
                                        </Table.Column>

                                        <Table.Column flexGrow={1} sortable>
                                            <Table.HeaderCell>
                                                Type
                                            </Table.HeaderCell>
                                            <Table.Cell dataKey="boardAssignmentType">
                                                {rowData => (rowData.boardAssignmentType)}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} sortable>
                                            <Table.HeaderCell>
                                                Name
                                            </Table.HeaderCell>
                                            <Table.Cell dataKey="entityName">
                                                {rowData => (rowData.entityName)}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} sortable>
                                            <Table.HeaderCell>
                                                Date Created
                                            </Table.HeaderCell>
                                            <Table.Cell dataKey="dateCrte">
                                                {rowData => (rowData.dateCrte ? new Date(rowData.dateCrte).toLocaleDateString() : '')}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} sortable>
                                            <Table.HeaderCell>
                                                Date Received
                                            </Table.HeaderCell>
                                            <Table.Cell dataKey="dateReceived">
                                                {rowData => (rowData.dateReceived ? new Date(rowData.dateReceived).toLocaleDateString() : '')}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} sortable>
                                            <Table.HeaderCell>
                                                Status
                                            </Table.HeaderCell>
                                            <Table.Cell dataKey="boardMemberDecision">
                                                {rowData => (rowData.boardMemberDecision)}
                                            </Table.Cell>
                                        </Table.Column>
                                    </Table>
                                    <GenericPagination dataLength={actionedGrid.length} setPage={setActionedGridPage} setDisplayLength={setActionedGridLength} />
                                </>
                                : <LoadingSpinner />
                            }
                        </Card.Body>
                    </Card></Col>
            </Row>
        </Container>
    );
}
export default BoardApprovals;